import { connectToRequestContainerData } from "constants-lib/seo/connectToRequestContainerData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const getConnectToRequestContainer = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add Connect to Request Container JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addConnectToRequestContainer = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-connect-with-you-quickly-to-request-a-container-repair`,
    ) &&
    document.getElementById(`connectToRequestContainer`) === null
  ) {
    const script = connectToRequestContainerJSONLD()
    addJSONLDToHead(script, `connectToRequestContainer`)
  } else {
    removeElement(`connectToRequestContainer`)
  }
}

// JSON LD template for Connect to Request Container
const connectToRequestContainerJSONLD = () => {
  const connectToRequestTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getConnectToRequestContainer(connectToRequestContainerData),
  }
  return connectToRequestTemplate
}
